<template>
    <crud-show :title="title" :open="open"  @close="$emit('close')">

        <v-card-text>
            <canal-cobro-show-data :item="item" />
        </v-card-text>

  </crud-show>
</template>

<script>
    import CanalCobroShowData from "./CanalCobroShowData";
    import {CrudShow} from '@dracul/common-frontend'
 
    export default {
        name: "CanalCobroShow",
        components: {CrudShow, CanalCobroShowData},
        props: {
            open: {type: Boolean, default: true},
            item: {type: Object, required: true}
        },
        data() {
            return {
                title: 'cobrox.canalCobro.showing',
            }
        },
    }
</script>

